import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { MapTo } from "@adobe/aem-react-editable-components";
import classNames from "classnames";
import { VideoPlayer as ExternalVideoPlayer } from "@jti/ui";
import { withEditConfig } from "../../app-related/withAemAuthoring";
import styles from "./VideoPlayer.module.scss";
const VideoPlayerEditConfig = {
    emptyLabel: "Video Player",
    isEmpty: ({ desktopSrc, hostedExternally }) => !(desktopSrc || hostedExternally),
};
export const VideoPlayer = memo((props) => {
    if (VideoPlayerEditConfig.isEmpty(props))
        return null;
    const classes = classNames({
        [styles.container]: props.roundedCorners,
    });
    return _jsx(ExternalVideoPlayer, { ...props, className: classes });
});
export default MapTo("loyalty/components/video-player")(withEditConfig(VideoPlayer, VideoPlayerEditConfig));
